import { useSelector } from 'react-redux';
import InnerLayout from './InnerLayout';
import { selectLeftNavigate } from '../../store/slice/navigate';
import styles from './style/RightPanelLayout.module.scss';

const RightPanelLayout = ({ title, children }) => {
  const toggleLeftNavigation = useSelector(selectLeftNavigate);
  const leftNavigationShow = toggleLeftNavigation.toggleOpen;

  return (
    <InnerLayout>
      <div className={`${styles.dashboardOuter} ${!leftNavigationShow && styles.leftNavigationShow}`}>
        <div className={styles.header}>
          <div className={styles.title}>{title}</div>
        </div>
        {children}
      </div>
    </InnerLayout>
  );
};

export default RightPanelLayout;
